import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { t as typy } from 'typy'
import classnames from 'classnames'
import { IntlShape, injectIntl } from 'react-intl'

import PrimaryButton from 'src/components/UI/Button/PrimaryButton'
import { SpinnerIcon } from 'src/components/UI/Icon/Icon'
import checkoutMessages from 'src/checkoutMessages'
import messages from 'src/components/Cart/messages'

import styles from './CartSummary.module.scss'

type Props = {
  cart?: any
  handleClick?: () => void
  intl: IntlShape
}

type State = {
  code: string
  errorMessage: string
  pending: boolean
  success: boolean
}

@inject('cart')
@observer
class CartSummary extends React.Component<Props, State> {
  inputRef: React.RefObject<any>

  state = {
    code: '',
    errorMessage: '',
    pending: false,
    success: false,
  }

  constructor(props: Props) {
    super(props)
    this.inputRef = React.createRef()
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const code = e.target.value
    this.setState({
      code,
    })
  }

  onKeyUp = (e: any) => {
    this.setState({
      errorMessage: '',
    })
    if (e.key === 'Enter') {
      this.onSubmit()
    } else if (e.target.type === 'button' && e.key === ' ') {
      this.onSubmit()
    }
  }

  onSubmit = async (e?: React.FormEvent) => {
    if (e) {
      e.preventDefault()
    }
    const { cart } = this.props
    const { code } = this.state

    if (code) {
      this.setState({ pending: true })
      try {
        await cart!.voucher(code)
        this.setState({
          success: true,
        })
      } catch (err) {
        if (this.inputRef && this.inputRef.current) {
          this.setState({
            errorMessage: 'Ogiltig kod',
          })
          this.inputRef.current.focus()
        }
      }
      this.setState({ pending: false })
    }
  }

  render() {
    const { cart, handleClick, intl } = this.props
    const { formatMessage } = intl
    const { errorMessage } = this.state
    const itemsTotalPrice = typy(cart, 'cart.selection.totals.itemsTotalPrice')
      .safeObject
    const grandTotal = typy(cart, 'cart.selection.totals.grandTotalPrice')
      .safeObject
    const totalDiscountPrice = typy(
      cart,
      'cart.selection.totals.totalDiscountPrice'
    ).safeObject

    const errorMessageNode = this.state.errorMessage ? (
      <div className={styles.errorMessage}>{this.state.errorMessage}</div>
    ) : null

    return (
      <div className={styles.wrapper}>
        <div className={styles.totals}>
          {totalDiscountPrice && (
            <div className={styles.row}>
              <p>{'Subtotal'}</p>
              <p>{itemsTotalPrice}</p>
            </div>
          )}
          <React.Fragment>
            <div className={styles.voucher}>
              {totalDiscountPrice ? (
                <div className={styles.voucherSuccess}>{'Rabatt tillagd!'}</div>
              ) : (
                <React.Fragment>
                  <input
                    className={classnames(styles.input, {
                      [styles.inputError]: errorMessage,
                    })}
                    ref={this.inputRef}
                    autoComplete="off"
                    placeholder={formatMessage(
                      checkoutMessages.addGiftCardOrDiscountCode
                    )}
                    onKeyUp={this.onKeyUp}
                    onChange={this.onChange}
                  />
                  {errorMessageNode}
                </React.Fragment>
              )}
            </div>
            {totalDiscountPrice && (
              <div className={styles.row}>
                <p>{'Total rabatt'}</p>
                <p>{totalDiscountPrice}</p>
              </div>
            )}
          </React.Fragment>

          <div className={styles.totalsRow}>
            <p>{'Totalt'}</p>
            <p>{grandTotal}</p>
          </div>
        </div>
        <div className={styles.button}>
          <PrimaryButton
            onClick={handleClick}
            to={'/checkout'}
            disabled={cart.loading}
          >
            {cart.loading ? (
              <SpinnerIcon width={24} height={24} color="white" />
            ) : (
              formatMessage(messages.goToCheckout)
            )}
          </PrimaryButton>
        </div>
      </div>
    )
  }
}

export default injectIntl(CartSummary)
